import { isArray, isNumber } from '@sajari/react-sdk-utils';
import '../ContextProvider/controllers/Listener.esm.js';
import '../ContextProvider/controllers/analytics/Analytics.esm.js';
import '../ContextProvider/controllers/analytics/GoogleAnalytics.esm.js';
import FilterBuilder from '../ContextProvider/controllers/filters/FilterBuilder.esm.js';
import RangeFilterBuilder from '../ContextProvider/controllers/filters/RangeFilterBuilder.esm.js';
import '../ContextProvider/controllers/filters/combineFilters.esm.js';
import '../ContextProvider/controllers/Response.esm.js';
import '../ContextProvider/controllers/tracking/Tracking.esm.js';
import '../ContextProvider/controllers/tracking/ClickTracking.esm.js';
import '../ContextProvider/controllers/tracking/EventTracking.esm.js';
import '../ContextProvider/controllers/tracking/NoTracking.esm.js';
import '../ContextProvider/controllers/tracking/PosNegTracking.esm.js';
import '../ContextProvider/controllers/Pipeline.esm.js';
import '../ContextProvider/controllers/Variables.esm.js';

function isRange(value) {
  return isArray(value) && value.length === 2 && isNumber(value[0]) && isNumber(value[1]);
}
function rangeToParam(value) {
  return value.join(':');
}
function paramToRange(value) {
  return value.split(':').map(Number);
}
var initFiltersFromURLState = function initFiltersFromURLState(_ref) {
  var filters = _ref.filters,
      params = _ref.params;
  filters.forEach(function (filter) {
    if (filter instanceof FilterBuilder) {
      var key = filter.getField() || filter.getName();
      var value = params[key];

      if (value) {
        filter.set(value.split(','));
      }
    } else if (filter instanceof RangeFilterBuilder) {
      var _key = filter.getField() || filter.getName();

      var _value = params[_key] || '';

      var initialRange = paramToRange(_value);
      var limit = (params[_key + "_min_max"] || '').split(':').map(Number);

      if (isRange(initialRange)) {
        filter.set(initialRange);
      }

      if (isRange(limit)) {
        filter.setMin(limit[0]);
        filter.setMax(limit[1]);
        filter.setFrozen(true);
      }
    }
  });
};
var initVariableFromURLState = function initVariableFromURLState(_ref2) {
  var variables = _ref2.variables,
      mappingKeys = _ref2.mappingKeys,
      params = _ref2.params;
  var variableObj = {};
  mappingKeys.forEach(function (_ref3) {
    var paramKey = _ref3.paramKey,
        variableKey = _ref3.variableKey,
        defaultValue = _ref3.defaultValue;

    if (params[paramKey]) {
      variableObj[variableKey] = params[paramKey] || defaultValue;
    }
  });
  variables.set(variableObj);
};

export { initFiltersFromURLState, initVariableFromURLState, isRange, paramToRange, rangeToParam };
//# sourceMappingURL=queryParams.esm.js.map
